import { useHistoricalPercentageChangeData } from 'widgets/historicalPercentageChange/data/useHistoricalPercentageChangeData.ts';
import { useHistoricalPercentageChangeCapsuleConfigSlice } from 'widgets/historicalPercentageChange/capsule/store.ts';
import ReactCardFlip from 'react-card-flip';
import React, { useState } from 'react';
import { HistoricalPercentageChangeCapsuleFront } from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleFront.tsx';
import { HistoricalPercentageChangeCapsuleBack } from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleBack.tsx';
import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import { HistPriceVolDataState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';
import { computeChartData } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/chartData.ts';

export function HistoricalPercentageChangeCapsuleContent({
    streamData,
}: {
    streamData: HistPriceVolDataState;
}) {
    const items = useHistoricalPercentageChangeData(streamData);
    const [selectedItem, setSelectedItem] = useState<
        HistoricalPercentageChangeDataItem | undefined
    >();
    const { config, dispatchConfigChanged } =
        useHistoricalPercentageChangeCapsuleConfigSlice();

    const { periodQty, view } = config;

    const chartData = computeChartData(items, periodQty);

    const onChartClicked = (item?: HistoricalPercentageChangeDataItem) => {
        setSelectedItem(item);
        dispatchConfigChanged({ view: 'grid' });
    };

    const todaysItem: HistoricalPercentageChangeDataItem | undefined =
        items && items.length > 0 ? items[items.length - 1] : undefined;

    return (
        <div className="HistoricalPercentageChangeCapsuleContent">
            <ReactCardFlip
                isFlipped={view === 'grid'}
                flipDirection={'vertical'}
            >
                <div
                    key="front"
                    className="HistoricalPercentageChangeCapsuleFrontContainer flippable"
                >
                    <HistoricalPercentageChangeCapsuleFront
                        averageVolume={chartData.averageVolume}
                        items={items}
                        onClick={onChartClicked}
                    />
                </div>

                <div
                    key="back"
                    className="HistoricalPercentageChangeCapsuleBackContainer flippable"
                    onClick={() => dispatchConfigChanged({ view: 'chart' })}
                >
                    <HistoricalPercentageChangeCapsuleBack
                        averageVolume={chartData.averageVolume}
                        selectedItem={selectedItem ?? todaysItem}
                    />
                </div>
            </ReactCardFlip>
        </div>
    );
}
